export default function GetTimecardColumns(loaderColumns, setTimecardColumns){
    let gridColumns = [];
    for(const col in loaderColumns){
        let newGridCol = {field: loaderColumns[col]};
        gridColumns.push(newGridCol);
    };
    setTimecardColumns(gridColumns)
}